/* eslint-disable no-magic-numbers */
import { fontFamily } from './constants';
import { getRel, getRelX } from './utils/getRel';

export default function ContestText(relFontSize, text, title) {
	const cont = new PIXI.Container();
	if (title) {
		const titleObj = new PIXI.Text(title, {
			fontWeight: 'normal',
			fontSize: Math.floor(relFontSize * 0.6) + 'px',
			fontFamily: fontFamily,
			fill: '#FFFFFF',
			align: 'left',
			wordWrap: true,
			wordWrapWidth: getRelX(0.46),
		});
		titleObj.position = new PIXI.Point(0, -relFontSize);
		cont.addChild(titleObj);
	}
	const textObj = new PIXI.Text(text, {
		fontWeight: 'bold',
		fontSize: (relFontSize * (text > 22 ? 0.85 : 1)) + 'px',
		fontFamily: fontFamily,
		fill: '#FFFFFF',
		align: 'left',
		wordWrap: true,
		wordWrapWidth: getRelX(0.46),
	});
	cont.addChild(textObj);
	cont.position = getRel(-0.5, 0.3);

	return cont;
}
